import { Avatar } from './Avatar';
import { getAvatar } from '../../utils/avatar-store';

interface BotAvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function BotAvatar({ name, size = 'sm', className }: BotAvatarProps) {
  const a = getAvatar(name);
  return <Avatar name={name} size={size} imageUrl={a.imageUrl} presetColor={a.presetColor} className={className} />;
}
